import * as THREE from 'three';

// Create an empty scene
const canvas = document.getElementById('c-webgl');
const scene = new THREE.Scene();

// Create a basic perspective camera
const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
camera.position.z = 200;

// Create a renderer with Antialiasing
const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true });

// Configure renderer clear color
renderer.setClearColor("#ffffff");

// Configure renderer size
function onresize() {
  renderer.setSize(window.innerWidth, window.innerHeight, false);
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
};
window.onresize = function () {
  onresize();
};

// Create group
const group = new THREE.Group();
scene.add(group);

// Create a cube
const r = 250;
const geometry = new THREE.BoxGeometry(r, r, r);
const cube = new THREE.Mesh(geometry);

// Create bounding box
const box = new THREE.BoxHelper(cube, 0x000000);
box.material.blending = THREE.AdditiveBlending;
box.material.transparent = true;
group.add(box);

// Create particles
const particleCount = 2000;
const pMaterial = new THREE.PointsMaterial({
  color: 0xff999999,
  size: 2,
  transparent: true,
  sizeAttenuation: false
});
const particles = new THREE.BufferGeometry();
const particlePositions = new Float32Array(particleCount * 3);
const particleData = []

function makeVelocity() {
  return new THREE.Vector3(
    0.3 + Math.random() * 0.5,       // rightward x
    (Math.random() - 0.5) * 0.4,     // fan spread y
    (Math.random() - 0.5) * 0.4      // fan spread z
  );
}

for (let i = 0; i < particleCount; i++) {
  let xi = i * 3;
  let yi = i * 3 + 1;
  let zi = i * 3 + 2;

  // Distribute across volume for smooth start
  particlePositions[xi] = Math.random() * r - r / 2;
  particlePositions[yi] = Math.random() * r - r / 2;
  particlePositions[zi] = Math.random() * r - r / 2;

  particleData.push({ velocity: makeVelocity() });
}

particles.setDrawRange(0, particleCount);
particles.setAttribute('position', new THREE.BufferAttribute(particlePositions, 3).setUsage(THREE.DynamicDrawUsage));

const pointCloud = new THREE.Points(particles, pMaterial);
group.add(pointCloud);

// Mouse repulsion
const mouse = new THREE.Vector2(9999, 9999);
const mouseWorld = new THREE.Vector3();
const raycaster = new THREE.Raycaster();
const mousePlane = new THREE.Plane(new THREE.Vector3(0, 0, 1), 0);

window.addEventListener('mousemove', (e) => {
  mouse.x = (e.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(e.clientY / window.innerHeight) * 2 + 1;
});

window.addEventListener('touchmove', (e) => {
  const t = e.touches[0];
  mouse.x = (t.clientX / window.innerWidth) * 2 - 1;
  mouse.y = -(t.clientY / window.innerHeight) * 2 + 1;
}, { passive: true });

window.addEventListener('touchend', () => {
  mouse.set(9999, 9999);
});

const repulsionRadius = 20;
const repulsionStrength = 0.8;

// Render Loop
function render() {
  requestAnimationFrame(render);

  // Project mouse to world space at z=0
  raycaster.setFromCamera(mouse, camera);
  raycaster.ray.intersectPlane(mousePlane, mouseWorld);

  for (let i = 0; i < particleCount; i++) {
    let xi = i * 3;
    let yi = i * 3 + 1;
    let zi = i * 3 + 2;

    // Mouse repulsion
    const dx = particlePositions[xi] - mouseWorld.x;
    const dy = particlePositions[yi] - mouseWorld.y;
    const dist = Math.sqrt(dx * dx + dy * dy);
    if (dist < repulsionRadius && dist > 0) {
      const force = (repulsionRadius - dist) / repulsionRadius * repulsionStrength;
      particleData[i].velocity.x += (dx / dist) * force;
      particleData[i].velocity.y += (dy / dist) * force;
    }

    // Position by velocity
    particlePositions[xi] += particleData[i].velocity.x;
    particlePositions[yi] += particleData[i].velocity.y;
    particlePositions[zi] += particleData[i].velocity.z;

    // Reset when particle exits the right side or top/bottom/front/back
    if (
      particlePositions[xi] > r / 2 ||
      particlePositions[yi] > r / 2 || particlePositions[yi] < -r / 2 ||
      particlePositions[zi] > r / 2 || particlePositions[zi] < -r / 2
    ) {
      // Respawn at left edge, near center
      particlePositions[xi] = -r / 2;
      particlePositions[yi] = (Math.random() - 0.5) * r * 0.3;
      particlePositions[zi] = (Math.random() - 0.5) * r * 0.3;
      particleData[i].velocity = makeVelocity();
    }
  }

  pointCloud.geometry.attributes.position.needsUpdate = true;

  // Render the scene
  renderer.render(scene, camera);
};

onresize();
render();
